import styled from 'styled-components';
import { Button } from 'components/uikit/Button/Button';

export const ToMain = styled(Button).attrs(() => ({ theme: 3, size: 'l' }))`
  width: 100%;
`;
